import { FiltersInterface } from "../../../../Global/Interfaces/GlobalInterfaces";

export default class LeagueLeaderboardFilters implements FiltersInterface {
  templateId: string = null;
  limit?: number | null = null;
  page?: number | null = null;

  /**
   * @deprecated This property is no longer supported by the API and will be removed in a future version.
   * Please remove any usage of this property from your code.
   */
  groupId?: string = null;

  constructor(filters: any) {
    this.templateId = filters?.templateId || null;
    this.limit = filters?.limit || null;
    this.page = filters?.page || null;

    if (filters?.groupId !== undefined) {
      console.warn(
        "Warning: groupId property is deprecated and no longer supported by the API. " +
          "This property will be removed in a future version. Please update your code accordingly."
      );
    }
  }

  public constructFiltersUrl?(): string {
    let url = "";

    if (this.templateId) {
      url += `&template_id=${this.templateId}`;
    }

    if (this.limit) {
      url += `&limit=${this.limit}`;
    }

    if (this.page) {
      url += `&page=${this.page}`;
    }

    return url;
  }
}
